
import React from 'react';
import Svg, { Path } from 'react-native-svg';

const CheckIcon: React.FC<{ style?: object, color?: string, size?: number }> = ({ style, color = "currentColor", size = 24 }) => (
    <Svg style={style} width={size} height={size} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke={color}>
        <Path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
    </Svg>
);

export default CheckIcon;
